import UniversCommercialForm from "@features/creation/univers-commerciaux/components/UniversCommercialForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/univers-commerciaux/create")({
  loader: requirePermission(PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.CREATE),
  staticData: {
    title: "Nouvel univers commercial",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateUniversCommercialPage,
});

function CreateUniversCommercialPage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvel univers commercial</h1>
        <p className="text-sm text-base-content/60">
          Créer un nouvel univers commercial dans le catalogue Création
        </p>
      </div>
      <UniversCommercialForm />
    </div>
  );
}
